<template>
  <h2 class="Transmision_title">Nuestros planes por paquete</h2>
  <div class="plan-container">
    <div v-for="item in json" :key="item.id" class="plan-box">
      <div class="title-plan">
        <span>{{ normalizeNumberValidator(item.documents) }}</span> documentos
      </div>
      <div class="value-plan">
        <span>{{ colombianCurrencyValidator(item.value) }}</span>
      </div>
      <button v-on:click="selectPlan(item.value, item.documents)">
        Comprar
      </button>
    </div>
  </div>
  <PopUpTratamientoDatos 
      v-if="(!estadoTratamientoDatos && estadoTratamientoDatos != undefined) || storeTycVacio" :StoreVacio="storeTycVacio"
  ></PopUpTratamientoDatos>
  
  <div v-if="estadoTratamientoDatos">
    <PopUpRenovacionDebidaDiligencia v-if="mostrarPopUpDD" :estadoDD="estadoDD"></PopUpRenovacionDebidaDiligencia>
  </div>
  
  <div v-if="!mostrarPopUpDD && mostrarPopUpDD != null && estadoTratamientoDatos">
    <PopUpHabilitacion
  v-if="mostrarPopUpHabilitacion &&
  flujoHabilitacion == 'ON' &&
  empleadorHabilitado != undefined"
  :habProcesoRestringido="habProcesoRestringido"
  ></PopUpHabilitacion>

  <PopUpTerminosCondiciones v-if="empleadorHabilitado &&
  !estadoTerminosCondiciones &&
  (flujoHabilitacion == 'ON' || flujoAceptacionTDP == 'ON')
  "
  :textoPopUpTYC="textoPopUpTYC"
  :siguientePaginaTYC="siguientePaginaTYC"
  :nombreBotonConfirmTYC="nombreBotonConfirmTYC"
  :paginaOrigen="siguientePaginaTYC"
  :StoreVacio="storeTycVacio"
  @cerrarPopUpTYC="cerrarPopUpTYC">
  </PopUpTerminosCondiciones>
</div>
</template>

<script>
import {
  normalizeNumberValidator,
  colombianCurrencyValidator
} from "@/store/Payment/plans";
import { ref } from "@vue/reactivity";
import router from "@/router";
import { useMutations } from "@/store/helper";
import { computed, onBeforeMount, onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import PopUpRenovacionDebidaDiligencia from '@/components/DueDiligence/PopUpRenovacionDebidaDiligencia.vue';
import EstadoDebidaDiligencia from "../models/DueDiligence/EstadoDebidaDiligencia";
import { TipoMarca } from '../models/Payroll/Enums';
import PopUpHabilitacion from "@/components/DocumentosLegales/PopUpHabilitacion.vue"
import PopUpTerminosCondiciones from "@/components/DocumentosLegales/PopUpTerminosCondiciones.vue";
import Spinner from "@/components/layout/Spinner.vue";
import PopUpTratamientoDatos from "@/components/DocumentosLegales/PopUpTratamientoDatos.vue";

export default {
  name: "Plans",
  components: {
    Spinner,
    PopUpRenovacionDebidaDiligencia,
    PopUpHabilitacion,
    PopUpTerminosCondiciones,
    PopUpTratamientoDatos
  },
  setup() {
    const store = useStore();
    const { setStateMenu } = useMutations(["setStateMenu"]);
    const { setStateLoading } = useMutations(["setStateLoading"]);
    const mostrarPopUpDD = ref(null);
    const estadoDD = ref(0);
    setStateMenu(true);
    const json = ref([ ]);
    let featureFlag = ref(false);
    const estadoTratamientoDatos = computed(() => store.state.datosTycTtd.find((doc) => doc.nombreDocumento.includes("Tratamiento de Datos Personales"))?.aprobo);
    const estadoTerminosCondiciones = computed(() => store.state.datosTycTtd.find((doc) => doc.nombreDocumento.includes("Terminos y Condiciones"))?.aprobo);
    const idDocumentoTerminosCondiciones = computed(() => store.state.datosTycTtd.find((doc) => doc.nombreDocumento.includes("Terminos y Condiciones"))?.id);
    const empleadorHabilitado = computed(() => store.state.StateEmpleadorHabilitado);
    const textoPopUpTYC = ref("Gracias por elegir Aportes en Línea. En este momento no es posible continuar con la compra de planes para el servicio de Nómina Electrónica. Para completar tu compra, es necesario que aceptes la última versión de nuestros términos y condiciones.");
    const siguientePaginaTYC = ref("Plans");
    const nombreBotonConfirmTYC = ref("Continuar");
    const habProcesoRestringido = ref("Planes");
    const flujoHabilitacion = computed(() => store.state.StateflujoHabilitacion);
    const flujoAceptacionTDP = computed(() => store.state.StateFlujoAceptacionTDP);
    const mostrarPopUpHabilitacion = computed(() => {
      return !empleadorHabilitado.value && flujoHabilitacion.value == "ON"
    });
    const storeTycVacio = ref(false);
    
    function getListPlans() {
      setStateLoading(true);
      store.dispatch('GetListPlans', localStorage.getItem("Tokensin")).then(data => {
        json.value = [];
         data.data.forEach(element => {
           var plan =
           {
             id: element.planId,
             documents: element.cantidadDocumentos,
             value: element.valor
           };
           json.value.push(plan);
         });
        })
        .catch((err) => {
          console.error(err);
          setStateLoading(false);
        });
    }
    function selectPlan(value, documents) {
      localStorage.setItem("valuePlan", value);
      localStorage.setItem("documentsCount",documents);

      if(mostrarPopUpDD.value || mostrarPopUpHabilitacion.value)
      {
        router.push({ name: "Plans" })
      }
      else
      {
        router.push({name: "PaylinePaymentForm"});
      }
    }

    function MostrarOcultarPopUpDebidaDiligencia() {
      store.dispatch('validarEstadoParaMostrarComponenteDD').then((response) =>
      {
          estadoDD.value = response;
          if(response == EstadoDebidaDiligencia.ParaCrearNuevaDD)
          {
            var params = {
              Token: localStorage.getItem("Tokensin"),
              TipoMarca: TipoMarca.CompraPlanes
            };
            store.dispatch('ObtenerInfoMarca', params)
              .then((resp) => {
                if(!resp.data.activo){
                  mostrarPopUpDD.value = true;
                }
                else
                {
                  mostrarPopUpDD.value = false;
                }
              })
              .catch((err) => {
                console.error(err);
                setStateLoading(false);
              });
          }
          else
          {
            if(response == EstadoDebidaDiligencia.CreadaDD || response == EstadoDebidaDiligencia.RechazadaDD)
            {
              mostrarPopUpDD.value = true;
            }
            else
            {
              mostrarPopUpDD.value = false;
            }
          }

          setStateLoading(false);
      });
    }

    function refrescarValores()
    {
      if(store.state.datosTycTtd.length === 0)
      {
        store.dispatch('refrescarValoresDocumentosLegales').then(() =>{
        })
        .catch((err) => {
            console.error(err);
            setStateLoading(false);
            storeTycVacio.value = true;
          });
      }

      if(store.state.StateflujoHabilitacion == null)
      {
        store.dispatch('refrescarValoresFlujoHabilitacion').then(() => {
        })
        .catch((err) => {
            console.error(err);
            setStateLoading(false);
          });;
      }

      setStateLoading(false);
    }

    onMounted(() => {
      if (localStorage.getItem("TieneDatosContacto") == 'false'){
        router.push({ name: "EmployerContact" });
      } else {
        getListPlans();
      }
    });

    onBeforeMount(() => {
      MostrarOcultarPopUpDebidaDiligencia();
      refrescarValores();
    })
    return {
      json,
      selectPlan,
      normalizeNumberValidator,
      colombianCurrencyValidator,
      getListPlans,
      mostrarPopUpDD,
      estadoDD,
      estadoTratamientoDatos,
      estadoTerminosCondiciones,
      idDocumentoTerminosCondiciones,
      empleadorHabilitado,
      textoPopUpTYC,
      siguientePaginaTYC,
      nombreBotonConfirmTYC,
      flujoHabilitacion,
      flujoAceptacionTDP,
      mostrarPopUpHabilitacion,
      habProcesoRestringido,
      refrescarValores,
      storeTycVacio
    };
  },
  methods:{
    cerrarPopUpTYC()
    {
      this.estadoTerminosCondiciones = true;
    }
  }
};
</script>
